import React, { useRef, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Button1 from "../Buttons/Button1";
import Input from "../Input/Input-main";

const HeaderMain = ({ locationQuery, setLocationQuery }) => {
  const inputDestination = useRef(null);

  const handleDestinationClick = () => {
    let destination = inputDestination.current.value;
    let temp = `city=${destination}`;
    //console.log(temp);
    setLocationQuery(temp);
  };

  return (
    <div className="bg-white flex flex-row  justify-between py-1 shadow-shadowColor shadow-md pb-[9px] z-[2000] top-0 sticky transition-all">
      <div className="w-[10%]">
        <img
          src="/a2z-logo.png"
          className="h-[50px] w-[50px] rounded-full object-cover"
          alt="A2Z Villaz"
          className="mt-10 ml-10 md:mt-8 lg:mt-1 h-[5.9vw] scale-[0.8]"
        ></img>
      </div>
      {/* <HeaderForm /> */}
      <div class="relative w-1/4 flex flex-row border-black border-[1.5px] rounded-full my-auto">
        <img
          src="/Search.svg"
          onClick={handleDestinationClick}
          className="scale-[0.55] hover:cursor-pointer"
        ></img>
        <input
          ref={inputDestination}
          class="my-2  text-sm w-10/12 text-gray-900 rounded-lg bg-gray-50 bg-none outline-0"
          type="text"
          placeholder="Search Location or Property name"
        />
      </div>
      <div className="flex flex-row  justify-center mt-[24px] mr-[46px] ">
        <div className="mr-5 hover:cursor-pointer hover:scale-[1.05] ">
          <img src="/cart.svg"></img>
        </div>
        <div className="ml-4">
          <Link to="/signup" className="mr-5 scale-[0.8] md:scale-90">
            <Button1 value="Login/Signup" />
          </Link>
        </div>
      </div>
      {/* <Input /> */}
    </div>
  );
};

export default HeaderMain;
